import ItalicToolbarView from "./ItalicToolbarView.vue";
import {Italic as ItalicExtension} from "@tiptap/extension-italic";

export default class Italic {

    constructor() {
        this.toolbarView = ItalicToolbarView;
    }

    static create() {
        return new Italic();
    }

    getExtensions() {
        return [ItalicExtension];
    }
}